import React from 'react';
import { useTranslation } from 'react-i18next';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import scss from './EmptySearchResults.module.scss';

function EmptySearchResults() {
  const { t } = useTranslation('settings');

  return (
    <div className={scss.wrapper}>
      <Inventory2OutlinedIcon className={scss.icon} />
      <span className={scss.title}>{t('noDeletedMedia')}</span>
      <span className={scss.description}>{t('noDeletedMediaDescription')}</span>
    </div>
  );
}

export default EmptySearchResults;
